export const i18n = {
    zh: {
        // Common
        deprecated: '已弃用',
        frozen: '已冻结',
        version: '版本',
        since: '起始版本',
        deprecatedSince: '弃用版本',
        type: '类型',
        bitfield: '位字段',
        allowNull: '允许为空',
        note: '注意',
        argument: '参数',
        value: '值',
        description: '描述',
        compositorSupport: '合成器支持',
        noCompositorSupport: '未发现合成器支持',
        openSidebar: '打开侧边栏',
        openOutline: '打开大纲',

        // Sections
        mergeRequests: '合并请求',

        // Protocol info
        protocol: '协议',
        interface: '接口',
        request: '请求',
        event: '事件',
        enum: '枚举',
        entry: '项',

        // Misc
        newIdNote: '请注意，没有定义接口的 new_id 具有自定义序列化规则。',

        // Homepage
        homepageTitle: 'Wayland 协议文档',
        homepageSubtitle: '更优雅的 Wayland 文档查阅方式',
        homepageDescription: '汇总所有主流 Wayland 协议，无需在各种代码仓库和 XML 文件中翻找。',
        homepageStartReading: '从阅读',
        homepageCoreProtocol: '核心 Wayland 协议',
        homepageOrDiscover: '开始，或者发现一些',
        homepageUncutGems: '宝藏协议',

        // Footer
        footerDisclaimer: '本网站与 Wayland 官方项目无任何关联。网站所有内容均根据 Wayland 协议 XML 文件自动生成。',
        footerLicense: '本网站使用的 Visual Studio Code - Codicons 遵循 CC BY 4.0 许可。',
    },
    en: {
        // Common
        deprecated: 'Deprecated',
        frozen: 'Frozen',
        version: 'version',
        since: 'since',
        deprecatedSince: 'Deprecated since',
        type: 'Type',
        bitfield: 'bitfield',
        allowNull: 'allow null',
        note: 'Note',
        argument: 'Argument',
        value: 'Value',
        description: 'Description',
        compositorSupport: 'Compositor Support',
        noCompositorSupport: 'No compositor support found',
        openSidebar: 'Open sidebar',
        openOutline: 'Open outline',

        // Sections
        mergeRequests: 'Merge Requests',

        // Protocol info
        protocol: 'protocol',
        interface: 'interface',
        request: 'request',
        event: 'event',
        enum: 'enum',
        entry: 'entry',

        // Misc
        newIdNote: 'Keep in mind that new_id without defined interface has custom serialization rules.',

        // Homepage
        homepageTitle: 'Wayland Protocol Documentation',
        homepageSubtitle: 'A better way to read Wayland documentation',
        homepageDescription: 'The most popular Wayland protocols all in one place and without having to sift through different repositories and XML files.',
        homepageStartReading: 'Start by reading the',
        homepageCoreProtocol: 'core Wayland protocol',
        homepageOrDiscover: 'or discover some',
        homepageUncutGems: 'uncut gems',

        // Footer
        footerDisclaimer: 'This website is not affiliated in any way with the official Wayland project. All content on this website is automatically generated from the Wayland protocol XML files.',
        footerLicense: 'The Visual Studio Code - Codicons used on this website are licensed under CC BY 4.0.',
    }
}
